module.exports = __webpack_public_path__ + "lp/img/folder_icon_disabled.7343543f.svg";